// extracted by mini-css-extract-plugin
module.exports = {"item":"AppointmentForm_item__30_kF","error":"AppointmentForm_error__1BK3d","actions":"AppointmentForm_actions__4-6x3"};